var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { StyleItemWrapper } from '../StyleItemWrapper';
import { debounce } from "lodash-es";
import FileUploader from "../../../../../../lib/builtin/components/FileUploader";
const defaultOptions = [0, 1, 2, 4, 5, 8];
let BackgroundImage = class BackgroundImage extends Vue {
  get style() {
    return this.stylePanel.style;
  }
  get value() {
    const raw = /url\(\s*(['"]?)(.+?)(\1\s*?\))/.exec(this.style[this.propKey]);
    if (!raw) return '';
    return raw[2];
  }
  handleChange(value) {
    if (!value) {
      this.$delete(this.style, this.propKey);
    } else {
      this.$set(this.style, this.propKey, `url('${value}')`);
    }
  }
  created() {
    this.throttledInput = debounce(this.handleChange);
    this.$watch('value', () => this.throttledInput.cancel());
  }
  beforeDestroy() {
    this.throttledInput.cancel();
  }
  render() {
    const h = arguments[0];
    return h(StyleItemWrapper, {
      "attrs": {
        "propKey": this.propKey,
        "title": this.title
      },
      "style": "flex: 1"
    }, [h(FileUploader, {
      "attrs": {
        "value": this.value
      },
      "on": {
        "change": this.handleChange
      }
    })]);
  }
};
__decorate([Prop()], BackgroundImage.prototype, "title", void 0);
__decorate([Prop()], BackgroundImage.prototype, "propKey", void 0);
__decorate([Prop({
  type: Array,
  default: () => defaultOptions
})], BackgroundImage.prototype, "options", void 0);
__decorate([Inject()], BackgroundImage.prototype, "stylePanel", void 0);
BackgroundImage = __decorate([Component({})], BackgroundImage);
export { BackgroundImage };
//# sourceMappingURL=backgroundImage.js.map
